<template>
  <div class="bg-white flex justify-center">
    <div class="container">
      <DynamicZone v-if="page" :blocks="blocks" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { StrapiAttributesPage } from '@/types';

const strapi = useStrapiService();
const loading = ref(true);
// Properly type the page variable
const page = ref<StrapiAttributesPage | null>(null);
const blocks = ref<any[]>([]);

// Use GraphQL method instead of direct REST call to avoid CORS issues
try {
  // Use the GraphQL method which properly handles CORS through proxy
  page.value = await strapi.getPageBySlugGraphql("mobile-plans");
  console.log("page", page.value);
  
  // Only set blocks if we have components
  if (page.value?.components) {
    blocks.value = page.value.components;
  }
} catch (error) {
  console.error("Error fetching mobile-plans page:", error);
} finally {
  loading.value = false;
}
</script>
